/**
 * @class msysRequestError
 * @description
 *
 * # Purpose
 * This class is used to create a custom error type for the this.request() from msysListener.
 */

export default class msysRequestError extends Error {
  constructor(message, action, params, sender, target) {
    super(message)
    this.name = 'RequestError' // Custom name for the error type
    this.action = action
    this.params = params
    this.sender = sender
    this.target = target
  }
}
